{
  "schemaVersion": "1.0",
  "status": "DRAFT_DIRECTIONAL",
  "note": "Directional marketing content. Prices are management targets; public-pricing.json must be generated from Pricing Master at publish.",
  "moduleId": "platform-base",
  "worksWith": [
    {
      "type": "FOUNDATION_FOR",
      "target": "intelligence",
      "label": "Provides shared services"
    },
    {
      "type": "FOUNDATION_FOR",
      "target": "vault",
      "label": "Provides shared services"
    },
    {
      "type": "FOUNDATION_FOR",
      "target": "operate",
      "label": "Provides shared services"
    },
    {
      "type": "FOUNDATION_FOR",
      "target": "shop",
      "label": "Provides shared services"
    },
    {
      "type": "FOUNDATION_FOR",
      "target": "forge",
      "label": "Provides shared services"
    }
  ]
}